import React, { useState } from 'react';
import { ModalBlackFridayContainer } from './styles';
import ContagemRegressiva from 'src/components/ContagemRegressiva';
import { FiX } from 'react-icons/fi';

const ModalBlackFriday = () => {
  const [active, setActive] = useState(true);

  if (!active) return null; // some o modal quando fechar

return (
  <ModalBlackFridayContainer className='fadeIn'>
    <div className="content">

      <div className="closeButton" onClick={() => setActive(false)}>
        <FiX />
      </div>

      <h2 className='call1'>BLACK FRIDAY</h2>
      <p className='call2'>INGRESSO EXECUTIVO</p>
      <h3 className='call3'>R$ 99,00</h3>

      <div className="countdown">
        <ContagemRegressiva dataDesejada={new Date(`2025-11-29`)}/>
      </div>

      <a href='/app/venda-mais-passo-fundo/inscricao/venda-mais-passo-fundo-executivo'>
        <button className='call4'>ADQUIRA AGORA</button>
      </a>

    </div>
  </ModalBlackFridayContainer>
);
};

export default ModalBlackFriday;